export default "__VITE_ASSET__bab788d9__"